<template>
  <div>
    <!-- Status message -->
    <div :class="['status-title', statusColorClass]">
      {{ statusTitle }}
    </div>
    <!-- Text hiển thị với Card_Code highlight và link -->
    <div :class="containerClass" v-html="formattedMessage"></div>

    <!-- Bảng 2 cột với tiêu đề -->
    <div v-if="cardInfo && this.Scratch_Status === 'Success'" class="table-container">
      <div class="table-title">THÔNG TIN THẺ CÀO</div>
      <a-table
        :columns="columns"
        :dataSource="tableData"
        :pagination="false"
        rowKey="title"
        style="max-width: 400px; margin: 0 auto;"
        bordered
        size="small"
        :showHeader="false"
        class="custom-table"
      >
        <template slot="value" slot-scope="text">
          <span style="font-weight: normal;">{{ text }}</span>
        </template>
      </a-table>
    </div>

    <!-- Nút căn giữa -->
    <div v-if="cardInfo" class="btn-container">
      <a :href="`tel:*${cardInfo.Card_USSD}*${cardInfo.Card_Code}#`" class="btn btn-nap-tien">Nạp tiền</a>
      <button @click="copyCode" class="btn btn-sao-chep">Sao chép</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Scratch_Response',
  props: {
    MT_Message: { type: String, required: true },
    Scratch_Status: { type: String, required: true },
    PayType: { type: String, required: false, default: 'PREPAID' },
    User_ID: { type: String, required: false, default: '' },
  },
  data() {
    return {
      columns: [
        {
          title: '',
          dataIndex: 'title',
          key: 'title',
          customRender: (text) => `${text}`,
          width: 140
        },
        {
          title: '',
          dataIndex: 'value',
          key: 'value',
          scopedSlots: { customRender: "value" },
        }
      ]
    }
  },
  computed: {
    statusTitle() {
      switch (this.Scratch_Status) {
        case 'Success': return 'MÃ TRÚNG THƯỞNG HỢP LỆ';
        case 'Duplicate': return 'MÃ TRÚNG THƯỞNG ĐÃ ĐƯỢC SỬ DỤNG';
        case 'Wrong': return 'MÃ TRÚNG THƯỞNG KHÔNG CHÍNH XÁC';
        case 'Error': return 'CÓ LỖI XẢY RA';
        case 'NotYet': return 'CHƯƠNG TRÌNH CHƯA BẮT ĐẦU';
        case 'Block': return 'VƯỢT QUÁ LƯỢT TRÚNG THƯỞNG TRONG NGÀY';
        case 'BlackList': return 'VƯỢT QUÁ LƯỢT TRÚNG THƯỞNG CHƯƠNG TRÌNH';
        case 'EndTime': return 'CHƯƠNG TRÌNH ĐÃ KẾT THÚC';
        default: return '';
      }
    },
    statusColorClass() {
      return this.Scratch_Status === 'Success' ? 'status-title-success' : 'status-title-error';
    },
    containerClass() {
      switch (this.Scratch_Status) {
        case 'Success': return 'statustext status-success';
        case 'Duplicate': return 'statustext status-duplicate';
        case 'Wrong': return 'statustext status-wrong';
        case 'NotYet': return 'statustext status-duplicate';
        case '': return 'statustext status-empty';
        default: return 'statustext status-wrong';
      }
    },
    cardInfo() {
      if (!this.MT_Message) return null;
      const regex = /Mã thẻ cào\s*\(?\s*(viettel|mobifone|vinaphone)\s*\)? của bạn là\s*(\d{9,16})/i;
      const match = this.MT_Message.match(regex);
      if (!match) return null;
      const carrierRaw = match[1].toLowerCase();
      const code = match[2];
      let ussd = '';

      if (this.PayType === 'PREPAID') {
        ussd = '100';
      } else if (this.PayType === 'POSTPAID') {
        if (carrierRaw === 'viettel') ussd = '199';
        else if (carrierRaw === 'vinaphone') ussd = '188*0';
        else if (carrierRaw === 'mobifone') ussd = '100';
      } else {
        ussd = '100';
      }

      const Card_Carrier = carrierRaw.charAt(0).toUpperCase() + carrierRaw.slice(1);
      const USSD_Syntax = `*${ussd}*<mã thẻ cào>#`;
      return {
        Card_Carrier,
        PayType: this.PayType,
        USSD_Syntax,
        Card_Code: code,
        Card_USSD: ussd,
        User_ID: this.User_ID
      };
    },
    tableData() {
      if (!this.cardInfo) return [];
      console.log(this.User_ID);
      console.log(this.cardInfo);
      return [
        { title: 'Nhà mạng', value: this.cardInfo.Card_Carrier },
        { title: 'Loại thuê bao', value: this.cardInfo.PayType == "PREPAID" ? "Trả trước" : "Trả sau" },
        { title: 'Số điện thoại', value: this.cardInfo.User_ID },
        { title: 'Cú pháp nạp tiền', value: this.cardInfo.USSD_Syntax },
        { title: 'Mã thẻ cào', value: this.cardInfo.Card_Code }
      ];
    },
    formattedMessage() {
      if (!this.cardInfo) return this.MT_Message;
      const { Card_Code, Card_USSD } = this.cardInfo;
      const escapedCode = Card_Code.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
      const regexCode = new RegExp(escapedCode, 'g');

      return this.MT_Message.replace(
        regexCode,
        `<a href="tel:*${Card_USSD}*${Card_Code}#" class="card-code-link highlight">${Card_Code}</a>`
      );
    }
  },
  methods: {
    copyCode() {
      if (!this.cardInfo) return;
      const text = this.cardInfo.Card_Code;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('Đã sao chép mã thẻ!');
        }).catch(() => {
          this.$message.error('Sao chép thất bại');
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success('Đã sao chép mã thẻ!');
        } catch {
          this.$message.error('Sao chép thất bại');
        }
        document.body.removeChild(textArea);
      }
    }
  }
}
</script>

<style scoped>
.status-title {
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  margin-bottom: 8px;
}

.status-title-success {
  color: #28a745;
}

.status-title-error {
  color: #dc3545;
}

.statustext {
  padding: 5px;
  border-radius: 10px;
  line-height: 1.9;
}

.status-success {
  background-color: #d4edda;
  border: 1.5px solid #28a745;
  color: #155724;
  overflow: visible !important;
}

.status-duplicate {
  background-color: #fff3cd;
  border: 1.5px solid #ff8800;
  color: #7a4f01;
  overflow: visible !important;
}

.status-wrong {
  background-color: #f8d7da;
  border: 1.5px solid #dc3545;
  color: #721c24;
  overflow: visible !important;
}

.status-empty {
  background-color: #d1ecf1;
  border: 1.5px solid #007bff;
  color: #0c5460;
  overflow: visible !important;
}

div[class^="status-"] {
  border-radius: 6px;
  font-weight: 600;
  user-select: text;
  white-space: pre-wrap;
}

.table-container {
  margin: 20px auto 0 auto;
  max-width: 400px;
}

.table-title {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 6px;
  letter-spacing: 1px;
}

.table-bold {
  font-weight: bold;
}

.ant-table-cell .table-bold {
  font-weight: bold;
}

.card-code-link {
  color: #2a7d2a;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
.btn-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 15px;
}

.btn {
  padding: 8px 14px;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  border: none;
  transition: background-color 0.2s ease;
}

.btn-nap-tien {
  background-color: #28a745;
  color: white;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-nap-tien:hover {
  background-color: #218838;
}

.btn-sao-chep {
  background-color: #007bff;
  color: white;
}

.btn-sao-chep:hover {
  background-color: #0056b3;
}

.custom-table .ant-table-tbody > tr > td {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  height: 28px !important;
}
</style>